/**
 * @generated SignedSource<<f18c85ebb59f2830187285d05cd07231>>
 * @relayHash 12434cce84cd7d6cf51fa3586c50225e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 06cdcaf2c3d3bbcf3f6469e5c0b2ca739c27b9b317f463a07e81c17f15192550

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CardCoverManagerQuery } from './CardCoverManagerQuery.graphql';

const node: PreloadableConcreteRequest<CardCoverManagerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "06cdcaf2c3d3bbcf3f6469e5c0b2ca739c27b9b317f463a07e81c17f15192550",
    "metadata": {},
    "name": "CardCoverManagerQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
